module.exports = __webpack_public_path__ + "static/img/Onkyo.6066df41.png";